import { Icon as WIcon } from "@warp-ds/elements/react/icon";
import { useAppConfig } from "src/context/AppConfigProviderContext.tsx";

export const Icon = ({
  name,
  size = "small",
  className,
  ...props
}: { name: IconName; size?: IconSize; className?: string } & React.ComponentProps<typeof WIcon>) => {
  const { locale } = useAppConfig();
  return <WIcon name={name} size={size} locale={locale} className={className} {...props} />;
};

type IconSize = "small" | "medium" | "large" | "12px" | "16px" | "24px" | "32px" | "56px" | "64px";

type IconName =
  | "ActiveAds"
  | "Ads"
  | "AirCon"
  | "AirplaneBed"
  | "AllWheelDrive"
  | "AnimalPaw"
  | "Archway"
  | "ArrowDown"
  | "ArrowLeft"
  | "ArrowRight"
  | "ArrowUp"
  | "AwardMedal"
  | "BackWheelDrive"
  | "Bag"
  | "Bank"
  | "BankIdNo"
  | "BatteryEmpty"
  | "BatteryFull"
  | "BatteryHalfFull"
  | "Beach"
  | "Bell"
  | "BellFilled"
  | "Bin"
  | "Block"
  | "Boat"
  | "Bolt"
  | "Bookmark"
  | "Briefcase"
  | "BriefcaseUser"
  | "Browser"
  | "BrowserVerified"
  | "Building"
  | "BuildingPlot"
  | "Bulb"
  | "Burger"
  | "Bus"
  | "CabinHut"
  | "Calculator"
  | "Calendar"
  | "CalendarPlus"
  | "Camera"
  | "Cancel"
  | "Car"
  | "CarLeft"
  | "CarPart"
  | "CarRent"
  | "CarRight"
  | "Chair"
  | "Charger"
  | "Charter"
  | "ChatSupport"
  | "Check"
  | "Checklist"
  | "CheckShield"
  | "ChevronDoubleLeft"
  | "ChevronDoubleRight"
  | "ChevronDown"
  | "ChevronLeft"
  | "ChevronRight"
  | "ChevronUp"
  | "CirclePlus"
  | "CirclePlusFilled"
  | "CircleUser"
  | "CircleUserFilled"
  | "Clock"
  | "Close"
  | "Cog"
  | "ColorPalette"
  | "Confetti"
  | "Copy"
  | "CreditCard"
  | "Cursor"
  | "Delivery"
  | "Diner"
  | "Discount"
  | "Dislike"
  | "Door"
  | "Dots"
  | "DotsVertical"
  | "DoubleBed"
  | "Download"
  | "DragDots"
  | "Draw"
  | "Drawer"
  | "Drill"
  | "Drink"
  | "Dumbbell"
  | "Edit"
  | "Energy"
  | "Engine"
  | "EngineBelt"
  | "Error"
  | "Exchange"
  | "Expand"
  | "EyeOff"
  | "EyeOn"
  | "Facebook"
  | "Farm"
  | "FileAdd"
  | "Filter"
  | "Fireplace"
  | "Fishing"
  | "FrontWheelDrive"
  | "GasDiesel"
  | "GasFuel"
  | "GasHybrid"
  | "GearAutomatic"
  | "GearManual"
  | "GraphLine"
  | "GraphPie"
  | "Grid"
  | "Grill"
  | "Guitar"
  | "Headset"
  | "Heart"
  | "HeartRate"
  | "Hiking"
  | "History"
  | "Hotel"
  | "House"
  | "HouseBed"
  | "HouseFilled"
  | "HouseModern"
  | "HousePerson"
  | "IceSkater"
  | "Image"
  | "Info"
  | "Instagram"
  | "JetSki"
  | "Key"
  | "Lamp"
  | "Layers"
  | "Leaf"
  | "Lift"
  | "Like"
  | "Link"
  | "LinkExternal"
  | "ListSort"
  | "LockShield"
  | "Logout"
  | "LotusFlower"
  | "Luggage"
  | "Mail"
  | "Mailbox"
  | "Map"
  | "Megaphone"
  | "Messages"
  | "MessagesFilled"
  | "Minus"
  | "Mixer"
  | "Money"
  | "Motorcycle"
  | "Mountain"
  | "NoSmoking"
  | "OfficeDesk"
  | "Organize"
  | "Paperclip"
  | "Parking"
  | "Phone"
  | "PhoneCheck"
  | "PhoneScratched"
  | "PhoneUsed"
  | "PictureStack"
  | "PinMarker"
  | "PinRound"
  | "PlaneLand"
  | "PlaneTakeOff"
  | "Play"
  | "Playhouse"
  | "Plus"
  | "ProductBump"
  | "ProductCarousel"
  | "ProductHighlightListing"
  | "ProductNabolagsprofil"
  | "ProductStarred"
  | "ProductTop"
  | "Propeller"
  | "Question"
  | "Refresh"
  | "Road"
  | "Rocket"
  | "RoomService"
  | "RotateLeft"
  | "RotateRight"
  | "RowingBoat"
  | "Ruler"
  | "Sauna"
  | "ScrollUp"
  | "Search"
  | "Seat"
  | "Send"
  | "Share"
  | "Shipping"
  | "Shirt"
  | "Shoes"
  | "ShoppingCart"
  | "Shower"
  | "Shrink"
  | "SingleCylinder"
  | "Skyscraper"
  | "SmileyGood"
  | "SmileyHappy"
  | "SmileyNeutral"
  | "SmileySad"
  | "Sofa"
  | "Sorting"
  | "Sparkles"
  | "Speedometer"
  | "Stairs"
  | "StarCheck"
  | "StarEmpty"
  | "StarFull"
  | "StarHalf"
  | "Store"
  | "StoreFront"
  | "Stove"
  | "Stroller"
  | "Success"
  | "Suitcase"
  | "SuitcaseTrolley"
  | "Support"
  | "Swimming"
  | "Tag"
  | "TaskList"
  | "TextBold"
  | "TextItalic"
  | "TextStrikethrough"
  | "TextUnderline"
  | "Theater"
  | "ThreeSixty"
  | "Ticket"
  | "TownHouse"
  | "Tractor"
  | "Tree"
  | "TrendDown"
  | "TrendFlat"
  | "TrendUp"
  | "Tshirt"
  | "TV"
  | "Up"
  | "Upload"
  | "User"
  | "UserGroup"
  | "Users"
  | "Vacuum"
  | "Vase"
  | "Verification"
  | "Wallet"
  | "Warning"
  | "Warranty"
  | "WashingMachine"
  | "WaterPitcher"
  | "Weight"
  | "Wheelchair"
  | "Wifi"
  | "Wrench"
  | "X"
  | "YouTube";
